import React from "react";
import { api } from "../../api/api";
import { useApi } from "../../core/hooks/useApi";
import { useConditional } from "../../core/hooks/useConditional";
import { DataContext, useDataContext } from "../../core/hooks/useData";
import { getQueryStringValue } from "../../core/route/Route";
import { Modal } from "../../core/ui/Modal";
import { newNotification } from "../../core/ui/Notification";
import { Spinner } from "../../core/ui/Spinner";
import { Icon } from "../../core/ui/icons";
import { toStr } from "../../core/utils/conversion";
import { account_invite } from "../../types";
import { Home } from "../Home";
import { Page } from "../Page";
import { RegisterModal } from "./RegisterModal";


export function AcceptInvitation(props: {

}) {

	const token = toStr(getQueryStringValue("token"));

	const invite = useApi({
		request: () => api.account_invite_get({
			token,
		}),
	}, [token]) as account_invite;

	const dataContext = useDataContext({
		initialValue: {
			given1: "",
			family: "",

		}
	});

	const [complete, setComplete] = React.useState(false);

	const registerModal = useConditional(() => {
		return (
			<RegisterModal
				initialValues={{
					email: invite.email,
					name: {
						given1: invite.name,
						family: "",
					}
				}}
				onClose={registerModal.close}
			/>
		)
	});


	return (
		<>
			<Home />

			{
				!complete &&
				<DataContext.Provider value={dataContext}>
					<Modal
						title="Accept Invitation"
						size="width-50vw"

						saveTitle="Accept"
						onCancel={() => {
							document.location.href = "/";
						}}
						onSave={() => {
							api.account_invite_accept({
								token,
							}).then(() => {
								newNotification({
									title: "Invitation Accepted",
									type: "modal",
									message: "You have accepted the invitation and can now access the account.",
								});
								setComplete(true);

							}).catch(() => {

							});
						}}
					>
						{
							!invite && <Spinner size="small" />
						}

						{
							invite &&
							<fieldset className="width-100pc">
								<legend>Invitation Details</legend>

								<div className="flex horiz align-start">
									<Icon type="handshake_color" />
									<div className="flex vert align-start gap-5">
										<div>You have been invited by <b>{invite.invitedByName}</b> to join the account <div className="tag">{invite.accountName}</div> which they manage.</div>
										<p><i>By accepting the invitation you will be able to use this service as a member of their account.</i></p>
										{
											(!invite.existingUser) &&
											<button
												className="primary"
												onClick={() => {
													registerModal.show({});
												}}
											>Register Now</button>
										}
									</div>
								</div>

							</fieldset>
						}


						{registerModal.render()}
					</Modal>
				</DataContext.Provider>
			}
		</>
	)
}